export default __webpack_public_path__ + "static/media/embajadas.d90833a9.png";